import { t } from "@lingui/macro";
import React, { useEffect, useState } from "react";

import { MinusIcon, PlusIcon } from "../../icons_v2/general";
import { Box, HStack, Text } from "../../primitive";
import { Button } from "../Button/Button";

export type CrementorProps = {
  isDisabled?: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  name?: string;
  onIncrement?: (val: number) => void;
  onDecrement?: (val: number) => void;
  value?: number;
  min?: number;
  max?: number;
  testID?: string;
};

export const Crementor = ({
  onDecrement,
  onIncrement,
  value = 0,
  min,
  max,
  isDisabled,
  isDecrementDisabled,
  isIncrementDisabled,
  testID,
}: CrementorProps) => {
  const [number, setNumber] = useState(value);

  const decrementTestID = testID ? `${testID}-decrement` : "decrement";
  const incrementTestID = testID ? `${testID}-increment` : "increment";

  const decrementDisabled =
    !!isDisabled ||
    !!isDecrementDisabled ||
    !!(min !== undefined && number <= min);
  const incrementDisabled =
    !!isDisabled ||
    !!isIncrementDisabled ||
    !!(max !== undefined && number >= max);

  const handleIncrement = () => {
    if (!incrementDisabled) {
      setNumber(number + 1);
      onIncrement && onIncrement(number + 1);
    }
  };

  const handleDecrement = () => {
    if (!decrementDisabled) {
      setNumber(number - 1);
      onDecrement && onDecrement(number - 1);
    }
  };

  useEffect(() => {
    setNumber(value);
  }, [value]);

  return (
    <HStack
      justifyContent={"space-between"}
      flexDirection="row"
      alignItems="center"
      borderRadius="2"
      borderWidth={1.5}
      borderColor="grayscale-500"
      px={3}
      height={48}
    >
      <Button
        variant="ghost"
        size="tiny"
        isDisabled={decrementDisabled}
        onPress={handleDecrement}
        testID={decrementTestID}
        leftIcon={<MinusIcon />}
        accessibilityLabel={t`Decrement button`}
      />
      <Box width={40} height={40} alignItems="center" justifyContent="center">
        <Text variant="mainSmallSemiBold">{number}</Text>
      </Box>
      <Button
        variant="ghost"
        size="tiny"
        isDisabled={incrementDisabled}
        onPress={handleIncrement}
        testID={incrementTestID}
        leftIcon={<PlusIcon />}
        accessibilityLabel={t`Increment button`}
      />
    </HStack>
  );
};
